import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    wrapper: 'relative flex items-center',
    label: 'sr-only',
    input:
      'peer invalid:text-error placeholder:text-secondary-hover disabled:placeholder:text-inactive disabled:text-inactive block w-full appearance-none px-3 pt-3 pb-3 font-light outline-none focus:outline-none',
    helperText: 'text-inactive px-4 pt-1 text-sm font-light',
    startAdornment: 'absolute top-1/2 left-0 h-6 -translate-y-1/2 pl-3',
    endAdornment: 'h-6 pr-3'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-error',
        input: 'text-error'
      }
    },
    withStartAdornment: {
      true: {
        input: 'pl-12'
      }
    },
    withBorder: {
      true: {
        wrapper: 'invalid:border-bg-delete-error border-b-1 border-black'
      },
      false: {
        wrapper: ''
      }
    }
  },
  defaultVariants: {
    withBorder: true
  }
});
